module.exports = __webpack_public_path__ + "img/slider_8.85d9bc2d.jpg";